import * as tslib_1 from "tslib";
import { listApi } from '../../../../../../api';
import formPc from '../../../../renderer/components/pc';
import { Button, DatePicker, Form, Icon, Input, Select, TreeSelect } from '@h3/antd-vue';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
let QueryWorkitem = class QueryWorkitem extends Vue {
    constructor() {
        super(...arguments);
        this.filterList = [];
        // 选人控件已选人员、部门集合
        this.selectedValue = [];
        // 展示选人控件弹窗
        this.showSelector = false;
        this.staffSelectorOpts = {
            selectOrg: true,
            selectUser: true,
            mulpitle: false,
            showModel: true,
            showSelect: true,
            placeholder: '请选择',
        };
        // 支持类型：短文本、日期、数值、选人控件、逻辑、关联表单
        this.queryData = {};
        this.queryType = {};
        this.queryDataCopy = {};
        this.RelevanceFormData = {};
        this.nameObj = {};
    }
    mounted() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let _data = this.data;
            try {
                if (typeof this.data === 'string') {
                    _data = JSON.parse(this.data);
                }
            }
            catch (error) {
            }
            this.filterList = _data.filter((d) => d.checked);
            this.filterList.forEach((d) => tslib_1.__awaiter(this, void 0, void 0, function* () {
                this.$set(this.queryData, d.code, d.formPropertyType === 81 || d.formPropertyType === 8 || d.type === 81 || d.type === 4 ? undefined : '');
                if (d.formPropertyType) {
                    this.$set(this.queryType, d.code, d.formPropertyType);
                }
                else {
                    this.$set(this.queryType, d.code, d.type);
                }
                this.$set(this.nameObj, d.code, { name: d.name, name_i18n: d.name_i18n });
                if (d.formPropertyType === 80 || d.formPropertyType === 81) {
                    yield this.getQueryList(d.relativeCode, d.code);
                }
            }));
            this.queryDataCopy = JSON.parse(JSON.stringify(this.queryData));
        });
    }
    onsearchs(v) {
        this.queryData = v;
    }
    resetFields() {
        this.queryData = this.queryDataCopy;
    }
    // 重置
    reset() {
        this.resetFields();
        this.$emit('reset', this.queryDataCopy);
    }
    search() {
        let list = {};
        console.log(this.queryData);
        for (let key in this.queryData) {
            if ([50, 51, 81].includes(this.queryType[key])) {
                this.queryData[key] && Array.isArray(this.queryData[key]) && this.queryData[key].length
                    ? (list[key] = {
                        type: this.queryType[key],
                        value: this.queryData[key],
                    })
                    : '';
            }
            else if ([80].includes(this.queryType[key])) {
                this.queryData[key] && Object.keys(this.queryData[key]).length
                    ? (list[key] = {
                        type: this.queryType[key],
                        value: this.queryData[key],
                    })
                    : '';
            }
            else {
                this.queryData[key] && (this.queryData[key] + '').trim()
                    ? (list[key] = {
                        type: this.queryType[key],
                        value: this.queryData[key],
                    })
                    : '';
            }
        }
        this.$emit('search', list, this.nameObj, this.queryData);
    }
    getPopupContainer(triggerNode) {
        return triggerNode.parentNode;
    }
    // 获取关联表单数据
    getQueryList(schemaCode, code) {
        const obj = {
            schemaCode,
            mobile: false,
            page: 0,
            size: 1000,
            filters: [],
        };
        listApi.getQueryList(obj).then((res) => {
            if (res.errcode === 0) {
                const data = res.data.content.map((x) => x.data);
                this.$set(this.RelevanceFormData, code, data);
            }
            else {
                this.$set(this.RelevanceFormData, code, []);
            }
        });
    }
    // 国际化
    getKey(cur) {
        let name = cur.name;
        if (cur.name_i18n) {
            let name_i18n;
            if (typeof cur.name_i18n === 'string') {
                name_i18n = JSON.parse(cur.name_i18n);
            }
            else {
                name_i18n = cur.name_i18n;
            }
            if (name_i18n[this.$i18n.locale]) {
                name = name_i18n[this.$i18n.locale];
            }
        }
        return name;
    }
    // 获取日期控件的Format
    setFormat(code) {
        const find = this.datatype.find((d) => d.key === code);
        if (find) {
            return find.options.format;
        }
        return 'YYYY-MM-DD';
    }
    // 获取选人控件的multi
    setMulti(code) {
        const find = this.datatype.find((d) => d.key === code);
        if (find) {
            return {
                selectOrg: false,
                selectUser: true,
                mulpitle: find.options.multi ? JSON.parse(find.options.multi) : false,
                showModel: true,
                showSelect: true,
                placeholder: '请选择',
            };
        }
        return {
            selectOrg: false,
            selectUser: true,
            mulpitle: false,
            showModel: true,
            showSelect: true,
            placeholder: '请选择',
        };
    }
    setMulti2(code) {
        // const find = this.datatype.find((d: any) => d.key === code);
        // if (find) {
        //   return {
        //     selectOrg: true,
        //     selectUser: false,
        //     mulpitle: find.options.multi ? JSON.parse(find.options.multi) : false,
        //     showModel: true,
        //     showSelect: true,
        //     placeholder: '请选择',
        //   };
        // }
        return {
            selectOrg: true,
            selectUser: false,
            mulpitle: false,
            showModel: true,
            showSelect: true,
            placeholder: '请选择',
        };
    }
    setMulti3(code) {
        // const find = this.datatype.find((d: any) => d.key === code);
        // if (find) {
        //   return {
        //     selectOrg: true,
        //     selectUser: false,
        //     mulpitle: find.options.multi ? JSON.parse(find.options.multi) : false,
        //     showModel: true,
        //     showSelect: true,
        //     placeholder: '请选择',
        //   };
        // }
        return {
            selectOrg: true,
            selectUser: false,
            mulpitle: true,
            showModel: true,
            showSelect: true,
            placeholder: '请选择',
        };
    }
    setMulti4(code) {
        return {
            selectOrg: true,
            selectUser: true,
            mulpitle: true,
            showModel: true,
            showSelect: true,
            placeholder: '请选择',
        };
    }
    /**
     * 选人控件placeholder多语言
     */
    placeHolderLang() {
        this.staffSelectorOpts.placeholder = this.$t('cloudpivot.flowCenter.pc.plzSelect');
    }
    closeQueryItem() {
        this.$emit('hide');
    }
    onLanguageChange(l) {
        this.placeHolderLang();
    }
};
tslib_1.__decorate([
    Prop()
], QueryWorkitem.prototype, "data", void 0);
tslib_1.__decorate([
    Prop()
], QueryWorkitem.prototype, "searchs", void 0);
tslib_1.__decorate([
    Prop()
], QueryWorkitem.prototype, "datatype", void 0);
tslib_1.__decorate([
    Watch('searchs')
], QueryWorkitem.prototype, "onsearchs", null);
tslib_1.__decorate([
    Watch('$i18n.locale')
], QueryWorkitem.prototype, "onLanguageChange", null);
QueryWorkitem = tslib_1.__decorate([
    Component({
        name: 'query-workitem',
        components: {
            AButton: Button,
            AIcon: Icon,
            AInput: Input,
            AForm: Form,
            AFormItem: Form.Item,
            ATreeSelect: TreeSelect,
            ASelect: Select,
            ASelectOption: Select.Option,
            ARangePicker: DatePicker.RangePicker,
            StaffSelector: formPc.StaffSelector,
        },
    })
], QueryWorkitem);
export default QueryWorkitem;
